import * as React from "react"
export const Svg_064 = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={58}
    height={59}
    fill="none"
  >
    <path fill="url(#a)" d="M43.437 47.377h10.426v5.759H43.437v-5.76Z" />
    <path fill="url(#b)" d="M38.511 39.544H58v4.377H38.51v-4.377Z" />
    <path fill="url(#c)" d="M4.137 47.377h10.426v5.759H4.137v-5.76Z" />
    <path
      fill="url(#d)"
      d="M48.453 5.864H9.547L6.378 20.308h45.244L48.453 5.864Z"
    />
    <path
      fill="url(#e)"
      d="M45.846 35.66v.429H58v-3.34h-9.292c-1.578 0-2.862 1.305-2.862 2.91Z"
    />
    <path fill="url(#f)" d="M22.886 39.544h12.228v4.377H22.886v-4.377Z" />
    <path fill="url(#g)" d="M0 39.544h19.489v4.377H0v-4.377Z" />
    <path
      fill="url(#h)"
      d="M.17 29.293h9.122c3.451 0 6.259 2.856 6.259 6.366v.43h26.898v-.43c0-3.51 2.808-6.366 6.259-6.366h9.121c-.588-2.699-2.638-4.844-5.258-5.529H5.429c-2.62.685-4.67 2.83-5.258 5.529Z"
    />
    <path
      fill="url(#i)"
      d="M12.154 35.66c0-1.606-1.284-2.912-2.862-2.912H0v3.34h12.154v-.428Z"
    />
    <defs>
      <linearGradient
        id="a"
        x1={45.847}
        x2={47.718}
        y1={48.241}
        y2={53.72}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="b"
        x1={43.018}
        x2={43.651}
        y1={40.201}
        y2={44.763}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="c"
        x1={6.548}
        x2={8.418}
        y1={48.241}
        y2={53.72}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="d"
        x1={16.841}
        x2={19.754}
        y1={8.031}
        y2={22.799}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="e"
        x1={48.657}
        x2={49.242}
        y1={33.249}
        y2={36.698}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="f"
        x1={25.713}
        x2={26.694}
        y1={40.201}
        y2={44.633}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="g"
        x1={4.507}
        x2={5.14}
        y1={40.201}
        y2={44.763}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="h"
        x1={13.504}
        x2={15.204}
        y1={25.613}
        y2={38.48}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="i"
        x1={2.811}
        x2={3.396}
        y1={33.249}
        y2={36.698}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
    </defs>
  </svg>
)